import { observer } from "mobx-react-lite";
import { useState } from "react";
import IAttachment from "../interfaces/IAttachment";
import { isImageFile } from "../utils/utils";
import AttachmentFile from "./AttachmentFile";
import styles from "./AttachmentList.module.css";
import AttachmentImage from "./AttachmentImage";
import EntitiesDelete from "./EntitiesDelete";
import GalleryProvider from "./GalleryProvider";
import FileInput from "./inputs/FileInput";

function AttachmentList({ attachments, onUpload, onDelete }: IAttachmentListProps) {
    const [attachmentKeyForDelete, setAttachmentKeyForDelete] = useState<string | null>(null);
    const images = attachments.filter(a => isImageFile(a.fileName));
    const files = attachments.filter(a => !isImageFile(a.fileName));

    return (
        <div className={styles.container}>
            {!!images.length && (
                <div className={styles.images}>
                    <GalleryProvider>
                        {images.map(image => (
                            <AttachmentImage
                                key={image.key}
                                url={image.url}
                                onDeleteClick={onDelete && (() => setAttachmentKeyForDelete(image.key))}
                            />
                        ))}
                    </GalleryProvider>
                </div>
            )}
            {!!files.length && (
                <div className={styles.files}>
                    {files.map(file => (
                        <AttachmentFile
                            key={file.key}
                            name={file.fileName}
                            url={file.url}
                            updatedAt={file.createdAt}
                            size={file.size}
                            onDeleteClick={onDelete && (() => setAttachmentKeyForDelete(file.key))}
                        />
                    ))}
                </div>
            )}
            {onUpload && <FileInput onFilesSelected={files => onUpload(files)} />}
            {attachmentKeyForDelete && (
                <EntitiesDelete
                    entityName="File"
                    entityCount={1}
                    onCancel={() => setAttachmentKeyForDelete(null)}
                    onDelete={() => {
                        onDelete!(attachmentKeyForDelete);
                        setAttachmentKeyForDelete(null);
                    }}
                />
            )}
        </div>
    );
}

export default observer(AttachmentList);

interface IAttachmentListProps {
    attachments: IAttachment[];
    onUpload?: (files: File[]) => void;
    onDelete?: (key: string) => void;
}
